import { Link, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import DashboardEorder from "../../components/Dashboard/DashboardEorder";
import Dashboardfifth from "../../components/Dashboard/DashboardFifth";
import Dashboardfourth from "../../components/Dashboard/Dashboardfourth";
import EOrderDash from "../../components/Dashboard/EOrderDash";
import HomeDash from "../../components/Dashboard/HomeDash";
import DashboardAmount from "../../components/Dashboard/dashboardAmount";
import Dashboardthird from "../../components/Dashboard/dashboardthird";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading";
import ShimmerLoader, { DashboardShimmer } from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PurchaseDash from "../../components/Dashboard/PurchaseDash";
import { URLS } from "../../API/API endpoints";
import axios from "axios";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import IsAddProd from "../../assets/Dashboard/IsAddProd.svg";
import IsMachineCode from "../../assets/Dashboard/IsMachineCode.svg";
import IsCashierSetup from "../../assets/Dashboard/IsCashierSetup.svg";
import IsAddUser from "../../assets/Dashboard/IsAddUser.svg";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { LineChart } from "@mui/x-charts/LineChart";
import axiosInstance from "../../AxiosInstance";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import averageordervalue from "../../assets/Dashboard/averageordervalue.svg";
import posorders from "../../assets/Dashboard/posorders.svg";
import postotalsales from "../../assets/Dashboard/postotalsales.svg";
import totalcreditvalue from "../../assets/Dashboard/totalcreditvalue.svg";
import posProfit from "../../assets/Dashboard/pos_profit.svg";
import posProfitPercentage from "../../assets/Dashboard/pos_profit_percentage.svg";

import dayjs from "dayjs";
import "dayjs/locale/ar"; // Arabic locale

const PosDashboard = ({ start, end, refreshKey }) => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dashbaordData, setDashbaordData] = useState({});

  useEffect(() => {
    GetdashboardData();
  }, [start, end, refreshKey]);

  const GetdashboardData = async () => {
    let payload = {
      company_id: company_id,
      lang: i18n.language == 'ar' ? 'ar_001' : 'en_US',
      start_date: start,
      end_date: end,

    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.POS_DASHBOARD, payload);
      // console.log("DATA===>", response?.data);

      if (response?.data?.result) {
        setDashbaordData(response?.data?.result);
      } else {
        setDashbaordData({});
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const topProducts = dashbaordData?.charts?.top_products || [];
  const dataset = topProducts?.slice(0, 10).map((item) => ({
    unit_sold: item.units_sold,
    product: i18n.language === "ar" ? item.product_name_ar : item.product_name,
  }));

  const values = [
    {
      img: postotalsales,
      heading: t("Total Sales"),
      productsleft: `EGP ${dashbaordData?.summary?.today?.sales
          ? dashbaordData?.summary?.today?.sales?.toFixed(2)
          : "0"
        }`,
      bgcolor: "#DBFBDA6B",
      textcolor: "#059003",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: posorders,
      heading: t("Orders"),
      productsleft: `${dashbaordData?.summary?.today?.orders || "0"}`,
      bgcolor: "#2F80ED29",
      textcolor: "#2F80ED",
      // subHeading: `(${t("Today")})`,
      action: () => navigate("/pos/orders"),
    },
    {
      img: averageordervalue,
      heading: t("Average Order Value"),
      productsleft: `EGP ${dashbaordData?.summary?.average_order_value
          ? dashbaordData?.summary?.average_order_value?.toFixed(2)
          : "0"
        }`,
      bgcolor: "#FFE5CD85",
      textcolor: "#EB853C",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: totalcreditvalue,
      heading: t("Total Credit Value"),
      productsleft: `EGP ${dashbaordData?.summary?.total_credit_value
          ? dashbaordData?.summary?.total_credit_value?.toFixed(2)
          : "0"
        }`,
      bgcolor: "#EB575729",
      textcolor: "#EB5757",
      action: () => navigate("/pos/credithistory"),
      //   wide: true,
    },
    {
      img: posProfit,
      heading: t("Profit"),
      productsleft: `EGP ${dashbaordData?.summary?.pos_profit
          ? dashbaordData?.summary?.pos_profit?.toFixed(2)
          : "0"
        }`,
      bgcolor: "#00BFA51F",
      textcolor: "#00BFA5",
      //   wide: true,
    },
    {
      img: posProfitPercentage,
      heading: t("Profit Percentage"),
      // productsleft: ` ${dashbaordData?.summary?.profit_percentage
      //   ? dashbaordData?.summary?.profit_percentage?.toFixed(2)
      //   : "0"
      //   } ${("%")}`,
      productsleft:
        dashbaordData?.summary?.profit_percentage !== undefined ? (
          <span dir="ltr">
            {dashbaordData.summary.profit_percentage.toFixed(2)}%
          </span>
        ) : (
          <span dir="ltr">0%</span>
        ),
      bgcolor: "#7E57C229",
      textcolor: "#7E57C2",
      //   wide: true,
    },
  ];

  const chartSetting = {
    yAxis: [
      {
        label: t("Units Sold"),
        labelStyle: {
          fontFamily: 'Cairo, sans-serif',
          fontWeight: 600, // optional
        },
      },
    ],
    margin: { left: 80, right: 70 }, // 👈 add space on the left'
    borderRadius: 7,
    series: [
      { dataKey: "unit_sold", label: t("Units Sold"), color: "#2F80ED" },
    ],
    height: 330,
    sx: {
      [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
        transform: "translateX(-30px)",
      },
    },
  };

  const salesData = dashbaordData?.charts?.daily_pos_sales || [];
  // Take last 14 entries
  const last14 = salesData.slice(-14);
  const xAxisData = last14.map((item) =>
    dayjs(item.order_date)
      .locale(i18n.language == "ar" ? "ar" : "en") // switch to Arabic
      .format("DD MMM")
  );
  const yAxisData = last14.map((item) => item.total_sales);

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#F6F7F9]">
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ">
          {loading ? (
            <div className=" mt-3 me-4">
              <DashboardShimmer />
            </div>
          ) : (
            <>
              <div
                className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 xl:grid-cols-4 me-4 mt-4`}
              >
                {Object.values(values).map((val, index) => (
                  <div
                    key={index}
                    className={`rounded-xl px-2 py-4 flex items-center shadow-sm transition-transform transform ${val.action ? "hover:scale-[1.02] hover:shadow-lg cursor-pointer" : ""
                      }`}
                    style={{ backgroundColor: val.bgcolor }}
                    onClick={val.action}
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-2">
                        <img src={val.img} alt="icon" className="w-10 h-10" />
                        <div className="flex flex-col">
                          <div className="flex flex-row items-center">
                            <p className="text-[13px] font-medium text-gray-700 truncate">
                              {val.heading}
                            </p>
                            <p className="text-[9px] font-medium text-[#111111B2] ps-1">
                              {val.subHeading}
                            </p>
                          </div>

                          <p
                            className="text-xl font-bold"
                            style={{ color: val.textcolor }}
                          >
                            {val.productsleft}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div
                dir="ltr"
                className={`flex justify-between gap-4 mt-4 ${i18n.language == "ar" ? "ps-4" : "pe-4"
                  }`}
              >
                <div className="rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4 w-6/12 min-h-[380px]">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Daily Sales (14 Days)")}
                  </h3>
                  {yAxisData?.length > 0 ? (
                    <>
                      <LineChart
                        height={330}
                        xAxis={[
                          {
                            id: "days",
                            data: xAxisData,
                            scaleType: "point", // important when x values are strings
                          },
                        ]}
                        series={[
                          {
                            id: "Sales",
                            label: t("Daily Sales"),
                            data: yAxisData,
                            area: true,
                            color: "#1ABC9C",
                          },
                        ]}
                        margin={{ left: 80 }} // 👈 add space on the left
                        yAxis={[
                          {
                            label: t("Sales Value (EGP)"),
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif',
                              fontWeight: 600, // optional
                            },
                          },
                        ]}
                        sx={{
                          [`& .${axisClasses.directionY} .${axisClasses.label}`]:
                          {
                            transform: "translateX(-30px)",
                          },
                        }}
                        slotProps={{
                          legend: {
                            direction: "column", // row | column
                            position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                            padding: 0,
                            itemMarkWidth: 25, // size of color box
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              marginLeft: 5,
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                        }}
                      />
                      <p
                        style={{ fontWeight: 600 }}
                        className="font-medium text-[#111111] text-sm ms-64 -mt-4"
                      >
                        {t("Date")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4 w-6/12">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Top 10 Selling Products")}
                  </h3>
                  {dataset?.length > 0 ? (
                    <>
                      <BarChart
                        dataset={dataset}
                        xAxis={[
                          {
                            scaleType: "band",
                            dataKey: "product",
                            tickPlacement: "middle",
                            categoryGapRatio: 0.4,
                          },
                        ]}
                        {...chartSetting}
                        slotProps={{
                          legend: {
                            direction: "column", // row | column
                            position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                            padding: 0,
                            itemMarkWidth: 25, // size of color box
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              marginLeft: 5,
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                        }}
                      />
                      <p
                        style={{ fontWeight: 600 }}
                        className="font-medium text-[#111111] text-sm ms-64 -mt-4"
                      >
                        {t("products")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PosDashboard;
